import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { RootStyles } from "./styles/root";
import { MainLayout } from "./features/layout";
import { Main, Aulet, Activ, Kcell } from "./pages";
import { useLocale } from "./hooks";


function App() {
  const { lang, handleSetLang } = useLocale();

  return (
    <>
      <RootStyles/>
      <Router>
        <MainLayout lang={lang} setLang={handleSetLang}>
          <Routes>
            <Route exact path="/" element={<Main lang={lang}/>} />
            <Route exact path="/kcell" element={<Kcell lang={lang}/>} />
            <Route exact path="/activ" element={<Activ lang={lang}/>} />
            <Route exact path="/aulet" element={<Aulet lang={lang}/>} />
          </Routes>
        </MainLayout>
      </Router>
    </>
  );
}

export default App;
